import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import { IBulkShowHideDataInsightsDtos } from 'common/src/types/dataInsight.dtos';
import { IDataInsight, IPage } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from './constants';
import formatQueryParams from './formatQueryParams';
import { getRequest, patchRequest } from './requestTypes';

export const getDataInsights = async (
  params?: DataQueryParams,
): Promise<IPage<IDataInsight>> =>
  await getRequest(API_BASE_PATHS.METADATA.DATA_INSIGHTS, {
    ...formatQueryParams(params),
    _t: Date.now(),
  });

export const updateDataInsight = async (
  id: string,
  body: Partial<IDataInsight>,
): Promise<IDataInsight> =>
  await patchRequest(
    `${API_BASE_PATHS.METADATA.DATA_INSIGHTS}/${id}`,
    {},
    body,
  );

export const bulkUpdateDataInsights = async (
  dtos: IBulkShowHideDataInsightsDtos,
): Promise<void> => {
  await patchRequest(`${API_BASE_PATHS.METADATA.DATA_INSIGHTS}/bulk`, {}, dtos);
};
